/**
 * @file Submission read-only / review UI components — DatasetOverviewReadonlyBlock.tsx.
 */

import React from "react";

/** Type definition — Dataset Overview Readonly Block Props. */
export type DatasetOverviewReadonlyBlockProps = {
  title: string;
  meta?: string;
  children: React.ReactNode;
};

/** Flat subsection heading + content (A1/A2/A3 CMS sections). */
const DatasetOverviewReadonlyBlock: React.FC<DatasetOverviewReadonlyBlockProps> = ({
  title,
  meta,
  children,
}) => (
  <div className="readonly-form-block">
    <h3 className="readonly-form-block__title">{title}</h3>
    {meta ? <p className="readonly-form-block__meta">{meta}</p> : null}
    {children}
  </div>
);

/** React component — Dataset Overview Readonly Block. */
export default DatasetOverviewReadonlyBlock;
